import { getPrompt, getPromptAxios } from '@/api/chatGPT.js';
import constants from '@/constants/index.js';


export default {
    state: {
        prompts: [],
        defaultPrompt: null,

        isShowPromptAdd: false,
        isSavePromptAdd: false,
        promptDataAdd: {
            name: '',
            body: '',
            promt_exclude_words: '',
            programm_exclude_words: '',
        },

        isShowPromptEdit: false,
        isSavePromptEdit: false,
        promptDataEdit: null,
    },
    getters: {
        PROMPTS: state => {return state.prompts},
        DEFAULT_PROMPT: state => {return state.defaultPrompt},

        IS_SHOW_PROMPT_ADD: state => {return state.isShowPromptAdd},
        IS_SAVE_PROMPT_ADD: state => {return state.isSavePromptAdd},
        PROMPT_DATA_ADD: state => {return state.promptDataAdd},

        IS_SHOW_PROMPT_EDIT: state => {return state.isShowPromptEdit},
        IS_SAVE_PROMPT_EDIT: state => {return state.isSavePromptEdit},
        PROMPT_DATA_EDIT: state => {return state.promptDataEdit}
    },
    mutations: {
        PROMPTS: (state, payload) => { 
            state.prompts = structuredClone(payload);
            for (let index = 0; index < payload.length; index++) {
                if (payload[index].name.toLowerCase() == constants.DEFAULT_PROMPT_NAME) {
                    state.defaultPrompt = payload[index].id;
                    break;
                }
            }
        },
        PROMPTS_PUSH: (state, payload) => {
            state.prompts.push(structuredClone(payload));
        },
        PROMPTS_UPDATE: (state, {id, payload}) => {
            const promptIndex = state.prompts.map(prompt => prompt.id).indexOf(id);
            if (promptIndex >= 0) {
                state.prompts[promptIndex] = structuredClone(payload);
            }
        },
        PAG_PROVIDER_SPLICE: (state, id) => {
            const promptIndex = state.prompts.map(prompt => prompt.id).indexOf(id);
            if (promptIndex >= 0) state.prompts.splice(promptIndex, 1);
        },

        IS_SHOW_PROMPT_ADD: (state, payload) => {state.isShowPromptAdd = payload},
        IS_SAVE_PROMPT_ADD: (state, payload) => {state.isSavePromptAdd = payload},
        PROMPT_DATA_ADD_UPDATE: (state, {fieldName, fieldValue}) => {
            state.promptDataAdd[fieldName] = fieldValue;
        },

        IS_SHOW_PROMPT_EDIT: (state, payload) => {state.isShowPromptEdit = payload},
        IS_SAVE_PROMPT_EDIT: (state, payload) => {state.isSavePromptEdit = payload},
        PROMPT_DATA_EDIT_SET: (state, payload) => {
            state.promptDataEdit = structuredClone(payload);
        },
        PROMPT_DATA_EDIT_UPDATE: (state, {fieldName, fieldValue}) => {
            state.promptDataEdit[fieldName] = fieldValue;
        },
    },
    actions: {
        CHECK_PROMPTS: async function(context) {
            const prompts = context.getters.PROMPTS;

            if (prompts.length === 0) {
                const newPrompts = await getPrompt();
                context.commit('PROMPTS', newPrompts);
            }
        },
        CHECK_PROMPTS_AXIOS: async function(context) {
            if (context.getters.PROMPTS.length === 0) {
                const axiosPromise = await getPromptAxios();
                return axiosPromise;
            }
            return null;
        },

        CHECK_PROMPT_ADD: async function(context) {
            const data = context.getters.PROMPT_DATA_ADD;
            if (data.name === '') {
                context.commit('IS_SAVE_PROMPT_ADD', false);
                return 'To create a prompt, enter a name';    
            }
            if (data.body === '') {
                context.commit('IS_SAVE_PROMPT_ADD', false);
                return 'To create a prompt, enter a body';    
            }
            if (data.promt_exclude_words === '') {
                context.commit('IS_SAVE_PROMPT_ADD', false);
                return 'To create a prompt, enter a promt exclude words';    
            }
            if (data.programm_exclude_words === '') {
                context.commit('IS_SAVE_PROMPT_ADD', false);
                return 'To create a prompt, enter a programm exclude words';    
            }

            context.commit('IS_SAVE_PROMPT_ADD', true);
            return '';
        },
        CHECK_PROMPT_EDIT: async function(context) {
            const data = context.getters.PROMPT_DATA_EDIT;
            if (data.name === '') {
                context.commit('IS_SAVE_PROMPT_EDIT', false);
                return 'To save a prompt, enter a name';    
            }
            if (data.body === '') {
                context.commit('IS_SAVE_PROMPT_EDIT', false);
                return 'To save a prompt, enter a body';    
            }
            if (data.promt_exclude_words === '') {
                context.commit('IS_SAVE_PROMPT_EDIT', false);
                return 'To save a prompt, enter a promt exclude words';    
            }
            if (data.programm_exclude_words === '') {
                context.commit('IS_SAVE_PROMPT_EDIT', false);
                return 'To save a prompt, enter a programm exclude words';    
            }
            
            context.commit('IS_SAVE_PROMPT_EDIT', true);
            return '';
        }
    }
}